import React from "react";

export const Banner = () => {
  console.log(document.getElementById("vid"));

  return (
    <>
      <section className="banner_main">
        <article className="banner_container">
          <div className="banner_text">
            <div className="banner_title">
              <h1>
                ¡Con Davivienda,{" "}
                <span>
                  aprovechas <strong>lo del</strong> arriendo!
                </span>
              </h1>
            </div>
            <button
              className="banner_btn"
              onClick={() => {
                window.open("https://api.whatsapp.com/send/?phone=+573105653998", "_blank");
              }}
            >
              ¡Descubre cómo!
            </button>
          </div>

          <div className="banner_video">
            <video
              width="100%"
              id="vid"
              preload="metadata"
              controls
              autoPlay
              muted
              poster="https://leasingdavivienda.colraices.com/assets/img/poster.jpg"
            >
              <source
                src="https://leasingdavivienda.colraices.com/assets/video/leasing.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </article>
      </section>
    </>
  );
};
